import ContactComp from '../components/contactComp';

const Contact = () => {
    return <ContactComp />;
};

export default Contact;
